<template>
    <div class="col-span-12">
        <div class="flex -mx-2">
            <div v-for="tab in tabs" @click="activateTab(tab.num)" :class="{'opacity-50':activeTab != tab.num}" class="bg-white border-t-2 border-theme-1 border-b-0 mx-2 rounded-t-lg py-4 col-span-12 flex items-cenrter flex-col justify-center px-4 lg:px-8">
                <Tippy tag="img" :alt="tab.label" class="w-10 h-10 lg:w-20 lg:h-20 block mx-auto rounded-full" :src="require(`@/assets/images/` + tab.icon)" :content="tab.label" />
                <h2 class="block mt-4 text-center text-xs lg:text-md font-normal uppercase">{{tab.label}}</h2>
            </div>
        </div>
        <div class="bg-white p-8 rounded-lg rounded-tl-none">
            <div v-for="tab in tabs" v-if="activeTab == tab.num">
                <div v-if="tab.typeTab == 1 && tab.data">
                    <div v-for="(faker, fakerKey) in tab.data" :key="fakerKey" v-if="faker.parentNum != 0">
                        <carga-linea :data="faker" :index="fakerKey" :subType="tab.identificador" :canEdit="true"></carga-linea>
                    </div>
                </div>
                <div v-if="tab.typeTab == 2">
                    <button @click="crearOEditarEmpleado" class="ml-auto mb-4 dropdown-toggle cursor-pointer button text-white border bg-theme-11 flex items-center">
                        <PlusIcon class="mr-2" />
                        Nuevo Empleado
                    </button>
                    <div v-for="(empleado, index) in tab.data" :key="index" class="p-4 rounded-lg mb-4 bg-blue-100 border-2 border-blue-200">
                        <h2 class="select-none intro-y text-lg font-medium flex items-center justify-between">
                            <PlusIcon @click="toggle('empleado', empleado)" v-if="!toggledItems['empleado_' + empleado.num]" class="cursor-pointer text-blue-400 mr-2" />
                            <MinusIcon @click="toggle('empleado', empleado)" v-if="toggledItems['empleado_' + empleado.num]" class="cursor-pointer text-blue-400 mr-2" />
                            <span class="cursor-pointer hover:text-blue-700 w-full block" @click="toggle('empleado', empleado)">{{empleado.nombre_y_apellidos}}</span>
                            <p class="ml-auto text-xs text-red-500 flex-shrink-0" v-if="emptyFiles(empleado)">Faltan {{ emptyFiles(empleado) }} Documentos</p>
                            <button @click="crearOEditarEmpleado(empleado)" class="ml-4 hover:bg-blue-600 flex-shrink-0 hover:text-white dropdown-toggle cursor-pointer button text-white border shadow-lg text-gray-700 py-1 bg-white flex items-center">
                                <EditIcon class="mr-2" />
                                Editar Datos
                            </button>
                        </h2>
                        <div class="mt-8 w-full" v-if="toggledItems['empleado_' + empleado.num]">
                            <div v-for="(faker, fakerKey) in empleado.data[0].childs" :key="fakerKey">
                                <carga-linea :data="faker" :index="fakerKey" :subType="tab.identificador" :canEdit="true"></carga-linea>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="tab.typeTab == 3">
                    <button @click="crearOEditarSubcontrata" class="ml-auto dropdown-toggle cursor-pointer button text-white border bg-theme-11 flex items-center">
                        <PlusIcon class="mr-2" />
                        Nueva Subcontrata
                    </button>
                </div>
                <div v-if="tab.typeTab == 4">
                    <button @click="crearOEditarMaquinaria" class="ml-auto dropdown-toggle cursor-pointer button text-white border bg-theme-11 flex items-center">
                        <PlusIcon class="mr-2" />
                        Nueva Maquinaria
                    </button>
                    <div v-for="(maquinaria, index) in tab.data" :key="index" class="p-4 rounded-lg mb-4 bg-blue-100 border-2 border-blue-200">
                        <h2 class="select-none intro-y text-lg font-medium flex items-center justify-between">
                            <PlusIcon @click="toggle('maquinaria', maquinaria)" v-if="!toggledItems['maquinaria_' + maquinaria.num]" class="cursor-pointer text-blue-400 mr-2" />
                            <MinusIcon @click="toggle('maquinaria', maquinaria)" v-if="toggledItems['maquinaria_' + maquinaria.num]" class="cursor-pointer text-blue-400 mr-2" />
                            <span class="cursor-pointer hover:text-blue-700 w-full block" @click="toggle('maquinaria', maquinaria)">{{maquinaria.nombre_de_la_maquina}}</span>
                            <p class="ml-auto text-xs text-red-500 flex-shrink-0" v-if="emptyFiles(maquinaria)">Faltan {{ emptyFiles(maquinaria) }} Documentos</p>
                            <button @click="crearOEditarMaquinaria(maquinaria)" class="ml-4 hover:bg-blue-600 flex-shrink-0 hover:text-white dropdown-toggle cursor-pointer button text-white border shadow-lg text-gray-700 py-1 bg-white flex items-center">
                                <EditIcon class="mr-2" />
                                Editar Datos
                            </button>
                        </h2>
                        <div class="mt-8 w-full" v-if="toggledItems['maquinaria_' + maquinaria.num]">
                            <div v-for="(faker, fakerKey) in maquinaria.data[0].childs" :key="fakerKey">
                                <carga-linea :data="faker" :index="fakerKey" :subType="tab.identificador" :canEdit="true"></carga-linea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Begin : SUBCONTRATAS Second -->
        <div v-for="tab in tabs" v-if="activeTab == tab.num && tab.typeTab == 3">
            <div v-for="(subcontrata, index) in tab.data" :key="index" class="bg-white mt-8 p-8 rounded-lg">
                <div class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center ">
                    <Tippy tag="img" alt="Empresas" class="opacity-50 rounded-full mr-4" :src="require(`@/assets/images/businessman.svg`)" :content="`Empresas`" />
                    <h2 class="w-full intro-y text-lg font-medium flex items-center">
                        <PlusIcon @click="toggle('subcontrata', subcontrata)" v-if="!toggledItems['subcontrata_' + subcontrata.num]" class="cursor-pointer text-gray-400 mr-2" />
                        <MinusIcon @click="toggle('subcontrata', subcontrata)" v-if="toggledItems['subcontrata_' + subcontrata.num]" class="cursor-pointer text-gray-400 mr-2" />
                        <span @click="toggle('subcontrata', subcontrata)" class="hover:text-blue-700 cursor-pointer select-none">
                            <span class="block">{{ subcontrata.nombre_y_apellidos || subcontrata.nombre_de_la_empresa }}</span>
                            <span class="block text-xs text-gray-600">
                                {{ subcontrata.tipo }}
                                <span v-if="subcontrata.tipo == 'EMPRESA'">( {{ subcontrata.empleados.length }} empleados )</span>
                            </span>
                        </span>
                    </h2>
                    <p class="ml-auto text-xs text-red-500 flex-shrink-0" v-if="emptyFiles(subcontrata)">Faltan {{ emptyFiles(subcontrata) }} Documentos</p>
                    <button @click="crearOEditarSubcontrata(subcontrata)" class="ml-4 flex-shrink-0 hover:bg-gray-600 hover:text-white dropdown-toggle cursor-pointer button text-white border shadow-lg text-gray-700 text-lg py-1 bg-white flex items-center">
                        <EditIcon class="mr-2" />
                        Editar Datos
                    </button>
                </div>
                <div v-if="toggledItems['subcontrata_' + subcontrata.num]" class="mt-8">
                    <div v-for="(faker, fakerKey) in subcontrata.data[0].childs" :key="fakerKey">
                        <carga-linea :actual_depth="3" :data="faker" :index="fakerKey" :subType="tab.identificador" :canEdit="true"></carga-linea>
                    </div>
                </div>
                <div v-if="toggledItems['subcontrata_' + subcontrata.num] && subcontrata.tipo == 'EMPRESA'" class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mb-8 mt-8">
                    <Tippy tag="img" alt="Empresas" class="opacity-50 rounded-full mr-4" :src="require(`@/assets/images/businessman2.svg`)" :content="`Empresas`" />
                    <h2 class="intro-y text-lg font-medium ">EMPLEADOS</h2>
                    <button @click="crearOEditarEmpleado({subcontrata: subcontrata.num})" class="ml-auto dropdown-toggle cursor-pointer button text-white border bg-theme-11 flex items-center">
                        <PlusIcon class="mr-2" />
                        Nuevo Empleado
                    </button>
                </div>
                <div v-if="toggledItems['subcontrata_' + subcontrata.num] && subcontrata.tipo == 'EMPRESA'" v-for="(empleado, index) in subcontrata.empleados" :key="index" class="p-4 rounded-lg mb-4 bg-blue-100 border-2 border-blue-200">
                    <h2 class="intro-y text-lg font-medium flex items-center justify-between">
                        <PlusIcon @click="toggle('empleado', empleado)" v-if="!toggledItems['empleado_' + empleado.num]" class="cursor-pointer text-blue-400 mr-2" />
                        <MinusIcon @click="toggle('empleado', empleado)" v-if="toggledItems['empleado_' + empleado.num]" class="cursor-pointer text-blue-400 mr-2" />
                        <span class="cursor-pointer hover:text-blue-700" @click="toggle('empleado', empleado)">{{empleado.nombre_y_apellidos}}</span>
                        <p class="ml-auto text-xs text-red-500" v-if="emptyFiles(empleado)">Faltan {{ emptyFiles(empleado) }} Documentos</p>
                        <button @click="crearOEditarEmpleado(empleado)" class="ml-4 hover:bg-blue-600 hover:text-white dropdown-toggle cursor-pointer button text-white border shadow-lg text-gray-700 py-1 bg-white flex items-center">
                            <EditIcon class="mr-2" />
                            Editar Datos
                        </button>
                    </h2>
                    <div v-if="toggledItems['empleado_' + empleado.num]" class="mt-8 w-full">
                        <div v-for="(faker, fakerKey) in empleado.data[0].childs" :key="fakerKey">
                            <carga-linea :actual_depth="3" :data="faker" :index="fakerKey" :subType="tab.identificador" :canEdit="true"></carga-linea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End : SUBCONTRATAS Second -->
    </div>
</template>
<script>
import CargaLinea from "@/components/CargaLinea";
import Vue from "vue";

export default {
    components: {
        CargaLinea
    },
    props: ["centro"],
    data() {
        return {
            toggledItems: {},
            tabs: [
                { num: 1, identificador: "EMPRESA", label: "Empresa", icon: "businessman.svg", typeTab: 1 },
                { num: 2, identificador: "EMPLEADOS", label: "Empleados", icon: "businessman2.svg", typeTab: 2 },
                { num: 3, identificador: "SUBCONTRATAS", label: "Subcontratas", icon: "businessman3.svg", typeTab: 3 },
                { num: 4, identificador: "MAQUINARIA", label: "Maquinaria", icon: "maquinaria.svg", typeTab: 4 },
            ],
            empleados: [],
            subcontratas: [],
            centroSeleccionado: null,
            activeTab: 1
        }
    },
    mounted() {
        this.reload();
        window.bus.$on("dataReloaded", () => {
            this.reload();
        });
    },
    methods: {
        toggle(name, item) {
            // El doble !! es para convertir indefinidos a boolean. !undefined => !true => false. El tercero es para hacer el toggle.
            Vue.set(this.toggledItems, name + '_' + item.num, !!!this.toggledItems[name + '_' + item.num])
        },
        reload() {
            this.tabs = this.tabs.map((tab) => {
                var centro = this.$d().user.centro;
                if (centro && centro.config && centro.config[tab.identificador]) {
                    if (tab.identificador == "SUBCONTRATAS") {
                        Vue.set(tab, "data", centro.config[tab.identificador]);
                    } else if (tab.identificador == "EMPLEADOS") {
                        Vue.set(tab, "data", centro.config[tab.identificador]);
                    } else if (tab.identificador == "EMPRESA") {
                        Vue.set(tab, "data", centro.config[tab.identificador]["data"][0]["childs"]);
                    } else if (tab.identificador == "MAQUINARIA") {
                        Vue.set(tab, "data", centro.config[tab.identificador]);
                    }
                }
                return tab;
            });
            if (this.centro) this.centroSeleccionado = this.centro;
        },
        activateTab(num) {
            if(this.activeTab == num) {
                this.toggledItems = {};
            }
            this.activeTab = num;
        },
        crearOEditarEmpleado(data = {}) {
            window.bus.$emit("modalCrearEmpleado", data);
        },
        crearOEditarSubcontrata(data = {}) {
            window.bus.$emit("modalCrearSubcontrata", data);
        },
        crearOEditarMaquinaria(data = {}) {
            window.bus.$emit("modalCrearMaquinaria", data);
        }
    }
}
</script>